import script from "./LoginPage3.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage3.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage3.vue?vue&type=style&index=0&id=1fe92b71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe92b71"]])

export default __exports__